import { Component, OnInit } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { Company } from '../../../models/company';
import { Router } from '@angular/router';
import { Page } from '../../../models/paging/page';
import { PDAUserService } from '../../../services/pda-user.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { ModalService } from '../../../services/modal.service';
import { CheckUserType } from '../../../models/checkUserType';
import { AuthService } from '../../../services/auth.service';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-pda-users',
  templateUrl: './pda-users.component.html',
  styleUrls: ['./pda-users.component.css']
})
export class PDAUserComponent implements OnInit {
  role = new CheckUserType();
  client;

  modalService: ModalService;
  companies: Company[];

  filter: any = {
    username: '',
    company_Id: 0,
    quick_Search: ''
  };

  availableOptions: string[] = [
    'First Name',
    'Last Name',
    'Company',
    'User Type',
    'Expired',
    'Edit',
    'Locked_Out'
  ];

  selectedOptions: string[] = [
    'First Name',
    'Last Name',
    'Company',
    'User Type',
    'Expired',
    'Edit',
    'Locked_Out'
  ];

  location_Id = 0;
  entity = "";
  showHistory: boolean = false;

  page = new Page();
  rows = Array<any>();
  init: boolean;

  constructor(private companyService: CompanyService, private pdaUserService: PDAUserService, private router: Router,
    modalService: ModalService, authService: AuthService, private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);

    this.modalService = modalService;
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  ngOnInit() {
    this.getcolumns();
    this.companyService.getAll(0).then((data) => {
      this.companies = data;
      this.loadTable(this.page);
      this.init = true;
    });
  }

  createCompany() {
    this.router.navigate(['users/tablet_management/manage']);
  }

  editUser(row: any) {
    this.router.navigate(['users/tablet_management/manage'], {
      queryParams: {
        user_Id: row.pdA_User_Id
      }
    });
  }

  /*openAuditHistoryPopup(row) {
    this.showHistory = true;
    this.location_Id = row.location_Id;
    this.entity = "Locations";
    this.modalService.open('popup-audit-log-history');
  }

  closeAuditHistoryPopup() {
    this.showHistory = false;
    this.modalService.close('popup-audit-log-history');
  }*/

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.pdaUserService.getResults(this.page, this.filter.username, this.filter.company_Id,
      this.filter.quick_Search
    ).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  generateExcel() {
    this.pdaUserService.getExcel(this.page, this.filter.username, this.filter.company_Id).then((data) => {
      importedSaveAs(data, 'Report.xlsx');
    });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "tabletUserManagement").then((data) => {
      if (data.columns != null) {       
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "tabletUserManagement", this.selectedOptions).then((data) => {
    });
  }
}
